<template>
  <div class="home">
    <div class="container">
      <div class="content mt-5">
        <div class="content-head">
        </div>
        <div class="content-body p-3 p-sm-5 d-flex align-items-center justify-content-center">
          <h1>Page not found</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Page404',
  mounted(){
  },
}
</script>
